module.exports = {
  COVID_19: 'Respiratory Coronavirus'
}
